<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre4">Bombs Awry</h1>
<div class="titlepage">
<h2 class="calibre5 sigil_not_in_toc" id="pgepubid00001">George O. Smith<br class="calibre6"/></h2>
</div>
<p class="ph">I</p>
<p class="calibre7">There were some new faces among the crew that crowded around him as
he came up the runway into the air-lock, and the <i class="calibre8">Vanguard</i>
rang with greeting: "Hi, Pete," or "Glad to see you again, Commander
Ellsworth," depending upon how well they knew him. Peter felt a bit
of nostalgia—but only briefly. The <i class="calibre8">Vanguard</i> had been both a
comfortable and interesting berth; but in every man's life there were
crossroads, and some of them demanded that he give up one course,
however pleasant, in favor of something more promising.</p>
<p class="calibre7">And some of them, like this one, took a man just across a tall fence,
and let him brush occasionally against his former existence.</p>
<p class="calibre7">"How're things going?" he asked.</p>
<p class="calibre7">Toby Reed grinned. "Fine. We've still got a fine gang, Peter. We're
stopping 'em all cold. We'll stop yours cold, too."</p>
<p class="calibre7">Peter felt a mild flash of professional hostility. He was no longer
one of them. He had no right to the "Commander" title any more. He
was "Ex-Commander" by proper title, if he owned any title at all. He
was on the Other Side. And the gang that once would have turned the
<i class="calibre8">Vanguard</i> inside out for Peter Ellsworth were now going to turn
it inside out to prove that they were smarter than Peter Ellsworth.</p>
<p class="calibre7">"Think you have anything?" asked Harry Lockwood.</p>
<p class="calibre7">Peter nodded. "Think I'd be handing it over to this gang of thieves if
I didn't?"</p>
<p class="calibre7">He felt that this was the course to take. He must be as confident as
they were. They were a smart outfit, and Peter was only one man;
yet Peter knew all the tricks himself, and he doubted that they had
invented many new ones. So unless someone had come up with about as
new a technique as could be, Peter would win. He had all the old bets
covered.</p>
<p class="calibre7">Actually, Peter had been covering them for years. There's a lot of free
time in a job like Peter's former command—time to watch and think
and plan and set down ideas. For seven years Peter Ellsworth had been
in command of the <i class="calibre8">Vanguard</i>, and in that time he had seen a
good many self-guided missiles launched in the ultimate test against
the <i class="calibre8">Vanguard's</i> highly-specialized countermeasures crew. He had
watched them all fail. He had taken careful note of the reasons. He had
worked with the crew against them—</p>
<p class="calibre7">What better training than this for a man who wanted to build one?</p>
<p class="calibre7">Down in the torpedo-hold were three shining metal cigars. Peter
Ellsworth's pets. His babies. Sunk into them were all of his hopes, all
his meager finances, and all the money that everybody who was Peter's
friend had been able to scrape up. He could not fail.</p>
<p class="calibre7">He waved to his former crew and went aloft to the pilot's bridge to see
the present commander.</p>
<p class="calibre7">"I'm Peter Ellsworth."</p>
<p class="calibre7">Commander Hogarth eyed him with interest. "You trained me a fine gang,"
he said warmly.</p>
<p class="calibre7">"They were a willing bunch."</p>
<p class="calibre7">Hogarth smiled. "You're hoping, but it's no go," he said cryptically.</p>
<p class="calibre7">"H'm?"</p>
<p class="calibre7">"Ellsworth, no matter how neutral a man is he can't help being human
first. In some situations like this a man could count upon human nature
to help him out. Not this time, Peter. Not this time. That gang below
would like to have you back. The only way to get you back is to ruin
your chances. They'll work hard at it. As for me, I could use an Exec.
Forester wants to transfer back to the heavies."</p>
<p class="calibre7">Peter shook his head. "I'm hocked up to the eyebrows," he said. "If I
fail this test, I'll be ruined. At an Executive Officer's pay it would
take me about two hundred and eighteen years of service to pay it back.
That's without eating."</p>
<p class="calibre7">"But you ought to know you can't win."</p>
<p class="calibre7">Peter shook his head again. "This time the <i class="calibre8">Vanguard</i> loses and I
win a nice fat contract. I know what a self-guided missile has to do."</p>
<p class="calibre7">Commander Hogarth chuckled. "And we'll find out how to wreck both your
hopes and your missile, Peter. Then you'll be back busting others
instead of building 'em. Why, even Ordnance hasn't come up with a good
one."</p>
<p class="calibre7">Peter nodded. "I know. But there's faulty reasoning in the theory that
Ordnance is the only outfit that knows anything about ordnance. That's
why I went into private venture. More real freedom of thought. I've had
it and I've used it, and now I'm here on the other side of the game to
prove it."</p>
<p class="calibre7">Hogarth started to reply, but Pilot Henderson snapped the squawk-box
key and announced: "Batten down! Takeoff in five minutes!"</p>
<p class="calibre7">Way down below in the bowels of the <i class="calibre8">Vanguard</i> the
field-generators began to build up. There was no more time for gab.
Everybody buttoned down for takeoff, and the <i class="calibre8">Vanguard</i> speared
the clouds on its needle-nose and went up and up into the black space
between the planets.</p>
<p class="calibre7">Out in the vast empty lot of the Solar System that laid beyond the
orbit of Saturn the <i class="calibre8">Vanguard</i> lay in wait for its war-game enemy.
In one sense it was like a game of solitaire. There were actually
two crews aboard the <i class="calibre8">Vanguard</i>, kept separate from one another
during the trials. The first was a skeleton crew trained to handle
the missiles, to check them out, finally to launch them against the
'enemy'. The second crew was the countermeasures crew who would take
over the operation of the <i class="calibre8">Vanguard</i> against the attack.</p>
<p class="calibre7">Every possible weapon would be used against the missile, every gadget,
every device, every brain.</p>
<p class="calibre7">If the <i class="calibre8">Vanguard's</i> crew succeeded there would be a space-borne
skyburst of flame that expended itself harmlessly. If the crew
failed—and they had never been known to fail—then the Countermeasures
Department lost three million dollars worth of guided drone. Not the
crews. They were safe in the <i class="calibre8">Vanguard</i>. Just the drone. The
guided spacecraft, the "enemy" spacecraft, which would be coupled
to every single motion that the <i class="calibre8">Vanguard</i> went through from
hatch-openings to main-battery fire to space maneuverings. From the
drone would come back the sighting-plate information for presentation
on the crew's plates, so that visible and audible information created
the illusion that they, themselves, were fending off a self-guided
missile loaded with a fission-flash warhead.</p>
<p class="calibre7">So perfect was the illusion that, in every such test, the crew swore
and sweated it out. It was the best operation that could be devised;
even better than using a live crew directly against the deadly things,
for someday the crew might fail.</p>
<p class="calibre7">Today, Peter hoped.</p>
<p class="calibre7">The squawk-box honked tinnily and Henderson said: "Drone at fifteen
kilos."</p>
<p class="calibre7">Commander Hogarth said: "Torpedo crew make ready and fire!"</p>
<p class="calibre7">There was a slight lurch as Peter Ellsworth's first pet whooshed out of
the torpedo tube. He saw it streak away to be gone almost instantly.
It was a tiny spot on the radar, curving outward in a veritable crawl
towards the spot fifteen thousand miles across space.</p>
<p class="calibre7">"Henderson, take over!" ordered Hogarth.</p>
<p class="calibre7">There was a lurch as Henderson thrust home a master toggle—the lurch
of Drone and Mother aligning together. From this moment on, the two
were near-identical. Turn for turn, trick for trick, weapon for weapon.
Acceleration for acceleration and direction for direction they were
one ship. Only in the matter of distance: fifteen thousand miles but
closing rapidly, and in the matter of velocity: the <i class="calibre8">Vanguard</i> was
loafing along while the Drone came up out of Sol's inner system at a
terrific velocity, were the two ships un-like.</p>
<p class="calibre7">They were chained together with a single, non-radiating communication
band of the Z-wave, multi-modulated in both directions so that attack
upon the Drone seemed to be attack against the Mother, and riposte by
the Mother turned out to be riposte against the missile from the Drone.</p>
<p class="calibre7">There was an electric-sounding sizzle from below; far across space
where the invisible Drone must be, there was a faint flowering of
violet as the primary beams lashed out. Someone below was testing the
main-battery.</p>
<p class="calibre7">Aboard the <i class="calibre8">Vanguard</i> were two factions. One of them (The Crew)
hoped to see the missile blossom in the emptiness like a futile flower.
The other (Peter Ellsworth) hoped that the crew would see their
sighting-plates flare before their eyes in the searing blast that
meant their destruction-in-simulation, and their defeat in reality.</p>
<p class="calibre7">It was a perfect set-up. The missile was as good as the best brains
could make it. The defense was as fine as could be collected together
from the men in the Space forces. Nothing could go wrong.</p>
<p class="calibre7">But it did.</p>
<p class="ph">II</p>
<p class="calibre7">It was no failure of man or machine. It was a coincidence so impossibly
improbable that only the Divine Intervention of a Deity who was tired
of His paper-work could be used as an explanation.</p>
<p class="calibre7">Chuckling in some mysterious Godlike humor, He picked up a meteorite
that had been serving as a paperweight on His desk to hold down a sheaf
of supplications and prayers. He wound up magnificently, having watched
some of His minions playing in the Heavenly Series.</p>
<p class="calibre7">He pitched a clean strike.</p>
<p class="calibre7">The meteorite drilled the Drone right through the middle of
Capricorn. The Drone exploded in a puff of flame that flashed in the
sighting-plates in the <i class="calibre8">Vanguard</i> only briefly before they blacked
out.</p>
<p class="calibre7">Commander Hogarth employed a series of robust verbs and adverbs and
nouns in a long sentence that ended with its subject: "—ing meteorite!"</p>
<p class="calibre7">Then he asked Henderson: "How long before we can get another Drone out
here?"</p>
<p class="calibre7">"About two hours. I'll have to compute. But—"</p>
<p class="calibre7">"Okay. Tell the crew to take a break. Get the galley to run up some
coffee-and. Give the whole outfit a Green Alert. We'll pick it up
later. Ellsworth, how's about some grub?"</p>
<p class="calibre7">"Okay by me."</p>
<p class="calibre7">"Can you get control of that gizmo of yours and hold it until the next
Drone comes up?"</p>
<p class="calibre7">Peter Ellsworth followed Commander Hogarth towards the ladder, saying
with a sly grin: "Nope. If I could control it, your countermeasures
gang could louse it, remember?"</p>
<p class="calibre7">"That's true. Well—" Hogarth stopped short, staring at Peter's face,
which had suddenly fallen into an expression of almost ludicrous dismay.</p>
<p class="calibre7">Peter gasped, "Holy jumping catfish!" and grabbed Hogarth by the arm:
"We'd better get the hell away from here—fast!"</p>
<p class="calibre7">"Why?"</p>
<p class="calibre7">Peter started for the squawk-box. Hogarth got in his way. "You're not
commander of this crate now, Peter. I'll have to give any orders after
you tell me why."</p>
<p class="calibre7">"There won't be time!"</p>
<p class="calibre7">"We'll make time. Now what's cooking?"</p>
<p class="calibre7">"The missile! It has crude memory circuits, that recall the
conditions of the selected target for about two hours after the initial
exposure ... they were put there in case a de-tracking maneuver should
cause the torpedo to lose its quarry! They'll search for a target that
fits the specifications contained in the memory banks and—"</p>
<p class="calibre7">"But—"</p>
<p class="calibre7">"Normally the missile would find the target and smash it. But <i class="calibre8">now
the target's gone</i> ... and the missile is still running around
loose, looking for a ship of X description! And from what I know of the
Countermeasures Operation, each Drone is practically identical with the
Mother ship—"</p>
<p class="calibre7">Hogarth's face went white. He leaped past Ellsworth and started up the
ladder. "Henderson!" he bawled. "Get mov—"</p>
<p class="calibre7">The din that cut Hogarth off was as clamorous as an air-raid siren
running in an empty ballroom. Sound racketed from bulkhead and deck as
the amplifiers ran full-throttle. The siren ceased abruptly long enough
for the stentorian cry:</p>
<p class="calibre7">"<i class="calibre8">Battle Stations!</i>"</p>
<p class="calibre7">Plate, girder and structure groaned as the <i class="calibre8">Vanguard</i> leaped up
at a full three-gravities and lurched. The Lanson generators in the
emergency hold whined high to cancel the gravity-apparent. Bulkhead
hatches slapped shut; tactic-lamps winked on; oil breakers plunged
home or came out as the normal load of the ship was switched from
cruising-power to battle-demands.</p>
<p class="calibre7">Two spacemen came up through the hatch, which flipped open just long
enough to let them through and then slammed closed again. One of them
went on up to the pilot's bridge. The other tackled a wire-sealed
locker with a heavy pair of cutters and came out with three spacesuits.
He hurled two of them at the commander and Peter Ellsworth and started
climbing into the third himself.</p>
<p class="calibre7">From the squawk-box came the cries:</p>
<p class="calibre7">"After Station Secure!"</p>
<p class="calibre7">"After Battery Alert!"</p>
<p class="calibre7">"Mid Battery Alert!"</p>
<p class="calibre7">"Communications Alert!"</p>
<p class="calibre7">"Foreturret Alert!"</p>
<p class="calibre7">"Radar and Countermeasures Section Alert!"</p>
<p class="calibre7">"Battlepower Stations Alert!"</p>
<p class="calibre7">"Report," came Henderson's voice. "We are attacked by the Ellsworth
Self-Guided Missile. I caught sight of it coming a-beam, just in time
to land on the acceleration. It missed by yards. It is now making an
off-beam swing, curving below and inward. It's going to come up from
behind at about five o'clock. Any orders, Commander Hogarth?"</p>
<p class="calibre7">"Repel it!" roared Hogarth. He looked at Peter. "How do we stop this
damned Juggernaut of yours?"</p>
<p class="calibre7">"I don't know," said Peter.</p>
<p class="calibre7">"You'd better find out!"</p>
<p class="calibre7">Peter shook his head. "Everything I could think of was rigged into it."</p>
<p class="calibre7">Hogarth snorted and went up the ladder to the pilot's bridge. Peter
followed.</p>
<p class="calibre7">The scene in space was depicted on the radar. Far behind and a bit
to one side, the missile was turning to follow them, coming around
in a graceful arc. The <i class="calibre8">Vanguard's</i> velocity-meter was mounting
swiftly; but not fast enough by far. The missile, much lighter than the
<i class="calibre8">Vanguard</i>, was capable of higher acceleration. Also there was no
need of a Lanson generator on the completely mechanical gadget, so that
the counter-fields and the necessary mass did not interfere with high
gee. So inevitably the missile would catch up with them, and that would
be that.</p>
<p class="calibre7">Hogarth looked at Ellsworth. "Radar?" he snapped.</p>
<p class="calibre7">"Radar, infra-red, visible light, and ultra-violet as well as mass."</p>
<p class="calibre7">"Countermeasures! Prepare and launch six radar corner-reflectors, three
fission-flash bombs, three oxy-hydrogen flares, two Röntgen radiators
and a Lanson generator."</p>
<p class="calibre7">Only seconds later there was a series of whooshing sounds as the items
were released. From below came a scattering of flares and blinkings
that fell behind as the ship's acceleration lifted it above the speed
of the countermeasures devices.</p>
<p class="calibre7">"Turn off the radar and the radio!" ordered Hogarth. "No radiation!
Henderson, turn up the Lanson—maybe we can change the pattern of the
<i class="calibre8">Vanguard</i>."</p>
<p class="calibre7">The <i class="calibre8">Vanguard</i> was hitting it space-ward at seven gravities
now and the accelerometer was climbing. As the Lanson generator was
turned up, the neutralized-to-normal gravity lightened so that each
hundred pounds weighed only about twenty-five. Henderson nursed the
rate-of-rise dial so that the acceleration increased more rapidly.</p>
<p class="calibre7">Radar complained: "What's going on?"</p>
<p class="calibre7">"Can't see. Dangerous to radiate."</p>
<p class="calibre7">"Dangerous to not-see," growled Radio.</p>
<p class="calibre7">"What do we do about it?" asked Hogarth.</p>
<p class="calibre7">Peter thought. "We're like a man being hunted by a vicious animal," he
said. "In order to run we've got to keep an eye on him—but if we can
see him, he can see us! I—Look, Hogarth, we're not using the Z-wave
that couples Drone and Mother, are we?"</p>
<p class="calibre7">"Not any more."</p>
<p class="calibre7">"Well, that's the one band that the missile is blind in," said Peter.
"We put in a filter so it wouldn't be able to follow the Z-wave ...
that's the only thing that isn't according to the specs. If you can
tune your radar to use Z-waves, you can make that tick at least.
Anything else you use to look at it will be an open door and a wide
road for it to follow."</p>
<p class="calibre7">"Why didn't you put in a disabling circuit?" complained Hogarth.</p>
<p class="calibre7">"So your gang couldn't find it and use it."</p>
<p class="calibre7">"But at least you could have slipped in a self-destruction circuit to
click off after a certain length of time."</p>
<p class="calibre7">Peter shook his head with a sour grin. "Why bother?" he said. "It
couldn't miss."</p>
<p class="calibre7">Hogarth roared, "You'd better pray that it does!"</p>
<p class="calibre7">Inaudible, but strong enough to feel through the frame of the ship,
the after-station battery went to work. It was a staccato bark, one
each second. A veritable hail of high-explosive shells roared back into
space.</p>
<p class="calibre7">One of the power-demand meters rose suddenly as the main beam-battery
lashed out with raw energy.</p>
<p class="calibre7">A pilot lamp winked on and off and on and off, each wink lighting
up the tiny words "Solid Mines" as two cannisters of two-inch steel
spheres were strewn in the trail of the <i class="calibre8">Vanguard</i>.</p>
<p class="calibre7">From the squawk-box came a cackling laugh as someone pulled the
inevitable, banal remark: "When you hear a pistol shot, duck; it's
inside the ship!"</p>
<p class="calibre7">Then the radar screen went on again. It was littered with flashing
motes; below them was the missile, coming up and up inexorably. As they
watched, sweating, a pale blue flash winked on its nose. The flash
became a needle-beam that flicked on and off, and at each flick one of
the high-explosive shells blossomed briefly in space. It did not bother
with shells that would be absolute misses; just those that might be
dangerous. The beam licked one of the countermeasures gadgets and the
flare blew out far and wide.</p>
<p class="calibre7">It came up through the curtain of gadgets without pause. The circuits
in its finder had decided some time before that these were diversions
and not its intended target. It ignored them all—except the one it
blasted out of its path.</p>
<p class="calibre7">The main beam-battery fired again; three barely-visible columns
of light streaked away from the <i class="calibre8">Vanguard</i> and thinned in
the distance. As the columns encountered the missile, the nose of
the torpedo disappeared behind a diaphanous-looking hemisphere of
pearly-flesh-colored hue. The powerful main-battery beams splashed away
from the missile's defences like water hitting a smooth stone.</p>
<p class="calibre7">Hogarth bawled: "Main Battery: off Beams!"</p>
<p class="calibre7">The beams winked out. The pearly radiance ceased and the pale blue
flicker came on again, dancing madly as it cleaned out a pathway
through the soliding mines. A shell, lazier than the rest, flared
briefly.</p>
<p class="calibre7">"Henderson: are we on emergency acceleration?"</p>
<p class="calibre7">"We're climbing."</p>
<p class="calibre7">"Climb faster!"</p>
<p class="calibre7">"Can't. We might overload the Lanson."</p>
<p class="calibre7">"Take a chance. We're dead if we don't."</p>
<p class="ph">III</p>
<p class="calibre7">The floor surged up below them; the accelerometer crawled up past
twenty gravities and kept on going. The complaining cry of the Lanson
could be heard throughout the ship now; its output could not keep up
with the increasing acceleration. Peter felt as though it must be at
least three gravities behind and lagging more and more.</p>
<p class="calibre7">The missile came on. Its slow, steady advance was maddening. Endowed
with a fiendish sentience, it seemed to know that sooner or later it
would win and therefore need not extend itself beyond its maker's
design.</p>
<p class="calibre7">The range kept closing.</p>
<p class="calibre7">"After Station reporting: target visible on the optics!"</p>
<p class="calibre7">Henderson snapped at the spaceman beside him: "Keep it in aim!"</p>
<p class="calibre7">The spaceman took the handles of the optical system and peered into the
eye-piece. In the glass above Henderson's board appeared the distant
mote that carried their numbers etched on its mechanical guts.</p>
<p class="calibre7">Fascinated, they watched it.</p>
<p class="calibre7">It grew.</p>
<p class="calibre7">It was still coming in from one side, still tending to line up its
drive with the drive of the ship, closing steadily. Henderson's
knuckles whitened on the steering controls; his feet fumbled for and
found the right pedals and put them under a slight pressure.</p>
<p class="calibre7">From behind there came the coughing of the heavy space rifles; three of
them side by side, barking in sequence and vomiting one high-explosive
shell every second. The space-mines light winked again and again. The
main-battery lashed at the missile; its beams splashed aside again,
even at this range. The battery-crew stopped, for want of power and to
let the projectors cool. The winking light on the nose of the missile
flickered madly and the space below the <i class="calibre8">Vanguard</i> became dotted
with shell-bursts and flickers from the solid mines.</p>
<p class="calibre7">A lamp winked on the board and Peter roared: "No! After Station, for
God's sake, <i class="calibre8">no</i>!"</p>
<p class="calibre7">The repeller-beam punched out, big and thick and tough as it went from
the throat of the projector, and thinning as it reached out for the
nose of the missile. It touched.</p>
<p class="calibre7">The pearly barrier screen winked on briefly and then it flickered off
again. In its place there came a larger flicker of the pale blue.</p>
<p class="calibre7">The ship staggered as it took the shock. The missile's self-defence
beam speared upward through the repeller-emplacement and the enclosure
exploded outward into space. There was a quick scream of escaping air,
cut off a split-second later as several safety-bulkheads slapped shut.</p>
<p class="calibre7">"Report!" roared Hogarth.</p>
<p class="calibre7">"Jones got clipped, but he's not killed. Get Medico, commander."</p>
<p class="calibre7">"Medico coming!" came another voice. Hatch-warning lamps on the panel
traced the course of the ship's doctor as he went below to the training
station for the repeller emplacement.</p>
<div class="figcenter" id="illus">
<img alt="" class="w" id="id-3410129173018521862" src="Images/img0003.jpg"/>
</div>
<p class="calibre7">"Torpedo Crew! Prepare and launch Missile Number Two!"</p>
<p class="calibre7">"Correct, sir. Take four minutes."</p>
<p class="calibre7">"Four?"</p>
<p class="calibre7">"We've anticipated you, sir."</p>
<p class="calibre7">"Henderson, have we got four?"</p>
<p class="calibre7">"Yes."</p>
<p class="calibre7">"Good, good. Torp Crew?"</p>
<p class="calibre7">"Yes?"</p>
<p class="calibre7">"Good work. Take four—take five if needed but no more."</p>
<p class="calibre7">"Make it three with luck, sir."</p>
<p class="calibre7">"Fire whenever you get the damned thing loaded."</p>
<p class="calibre7">Hogarth looked at Peter with a grim smile. "Why didn't you think of
that?"</p>
<p class="calibre7">"I did. It won't work."</p>
<p class="calibre7">"Why not? The defence against a perfect missile is to use another
perfect missile!"</p>
<p class="calibre7">"But the one that's running now is hot and ready. The new one will take
a few milliseconds to get to running heat. In that time—"</p>
<p class="calibre7">Hogarth growled. "We'll try it."</p>
<p class="calibre7">"Go ahead; but I say it won't work."</p>
<p class="calibre7">Hogarth half-turned away, and then swung back. "Look, Ellsworth, you
seem to forget one thing."</p>
<p class="calibre7">"What?"</p>
<p class="calibre7">"This is no longer a game! At this sitting if you prove your ability
to make a non-lousable missile you'll get the contract, all right, but
it'll go to your heirs and assigns—because in getting the contract
you'll lose your life. You can stay alive only by helping to screw up
that damned thing out there."</p>
<p class="calibre7">"What are you driving at?" Peter said coldly.</p>
<p class="calibre7">"I'm just thinking that no man ever made anything so perfect that it
couldn't be undone somehow. You're familiar enough with that gewgaw to
have developed some contempt for it. Now—what's its weak link?"</p>
<p class="calibre7">"There aren't any, according to my knowledge."</p>
<p class="calibre7">"Damn you, there must be!"</p>
<p class="calibre7">"I've spent a number of years thinking about it," said Peter. "Every
factor that could be thought of is covered."</p>
<p class="calibre7">"But <i class="calibre8">look</i> at it, man! Your life is riding on the nose of that
thing. What's money and position now?"</p>
<p class="calibre7">"Nothing," admitted Peter.</p>
<p class="calibre7">"Get used to the idea," snapped Hogarth angrily. "It's—"</p>
<p class="calibre7">The <i class="calibre8">Vanguard</i> lurched a trifle as the new torpedo was launched.
Everybody turned to watch in the optical system.</p>
<p class="calibre7">Missile Number Two whuffed out of the torpedo tube and started to turn
in a short arc that would make it intercept the course of Missile
Number One at precisely the same instant that Number One was passing
through that point on its course.</p>
<p class="calibre7">What happened then was merely a matter of circuitry. Number One
caught the new menace in its search beams and computed its course in
its think-machinery. The answer came out bad; this new device was a
definite menace, even though it was far to one side and still looping
away. It would return.</p>
<p class="calibre7">The tiny, pale blue flicker thickened into a ravening beam as it lashed
across space to drill into the newcomer.</p>
<p class="calibre7">The same sphere of pearly radiance flashed into being around Missile
Number Two, but it was not fast enough. The primary battery beam of
Number One was into the midsection of Number Two before the screen
went up. It did get up, however, to cut off the rest of the beam,
which splashed aside in a splatter of eye-aching fireworks and raised
the color of the barrier radiance. But the initial thrust of the beam
drilled home and Missile Number Two lost its drive. It faltered a bit
on its course; it wavered. It fell from power and loafed along for a
quarter of a minute before it burst in a blinding incandescence.</p>
<p class="calibre7">"And that," said Hogarth, "is what is in store for us—"</p>
<p class="calibre7">The Lanson, straining below, slipped a cog or missed a beat; more
likely, one of the overloaded parts flashed over to relieve the strain.
For a bare instant, everybody in the ship felt the full, bone-crushing
strain of more than thirty gravities. There was no question of its
being deadly in magnitude, and only the brief duration saved their
lives; the gravity switch did not even throw, and it was set for about
six gravities. The Lanson took up where it had left off, and the
<i class="calibre8">Vanguard</i> went on and on.</p>
<p class="calibre7">That bare instant was not long enough to cover more than a tiny portion
of Commander Hogarth's past life, but the high spots he hit made him
remember. He looked at Peter Ellsworth icily and said: "You know your
Regs, Ellsworth."</p>
<p class="calibre7">Peter nodded.</p>
<p class="calibre7">"Then you know that I have the power to call upon any man, civilian or
not, to perform whatever duty I feel is within his power."</p>
<p class="calibre7">"Do go on! Are you going to order me to stop this game?"</p>
<p class="calibre7">"I so order."</p>
<p class="calibre7">"Why not offer me a purse of money?" Peter said harshly.</p>
<p class="calibre7">"I'll have no contempt, Mister Ellsworth!"</p>
<p class="calibre7">"I'm not giving you contempt. I'm just telling you that if you think
for one moment that I'm not doing all I can to keep us in a whole skin,
you're thinking wrong as hell!"</p>
<p class="calibre7">"You'll—"</p>
<p class="calibre7">Peter held up a hand. "There is one way," he said thoughtfully.</p>
<p class="calibre7">Henderson's hands went whiter on the levers. Out of the corner of his
mouth Peter said, "Steady, spaceman."</p>
<p class="calibre7">"Best I can, sir."</p>
<p class="calibre7">"What way?" asked Hogarth.</p>
<p class="calibre7">"We'll have a fifty-fifty chance if we cut the ship in half! The
circuits in the missile won't register properly on a couple of
ship-halves—"</p>
<p class="calibre7">Hogarth grunted angrily. "Thus making it appear as though your missile
was unbeatable? Not on your life!"</p>
<p class="calibre7">Peter looked at Hogarth as he might have at a roach in his coffee. "I'm
still a young man," he said calmly. "I've been reasonably happy and I
dislike immensely the idea of dying. But if that's the way you feel,
I'll go along with you quietly—but with a big flare to mark the spot."</p>
<p class="calibre7">Hogarth's face was puffy and red. "I still have the power to impress
you as I think you're able. I hereby make you temporary Executive
Officer of the <i class="calibre8">Vanguard</i>—and since I have been on duty for three
hours without relief, I am going off duty, leaving you to command. I
have one order: <i class="calibre8">keep this ship intact!</i>"</p>
<p class="calibre7">"I suppose it's court martial if that critter of mine roughs it up a
bit?"</p>
<p class="calibre7">"Don't be banal. Just—"</p>
<p class="calibre7">"Cutting apart might be a good idea," suggested Henderson. "It—"</p>
<p class="calibre7">"You'll stay out of this!" roared Hogarth.</p>
<p class="calibre7">Peter turned to the intercom and opened the key: "Radar! Radio!
Countermeasures! Fire up!"</p>
<p class="calibre7">"What about the radiation-silence?" asked Radar.</p>
<p class="calibre7">"Forget it! The missile has our picture in its mind. We're not agile
enough to play squirrel, and there just ain't no place to hide. We
might as well radiate all we want and get a better picture of the
thing. Fire up!"</p>
<p class="calibre7">The blank screens went on; the one that had been pasted and patched to
use the Z-wave band winked out for a few seconds and then came back as
the regular—and more accurate—radar came back. The spaceman gave up
the optical sighter because it was no longer needed. The ranging-radar
and the course-finding radar, coupled together with a ton of electronic
equipment, produced a graphic diagram of the courses of missile and
target—including the point where they crossed. Time and range were
instantly computed, and the ordnance men in their turrets relaxed; the
various projectors were now aligning themselves automatically with the
intercept-spot.</p>
<p class="calibre7">The missile was a few thousand yards behind and closing up the distance
at an alarming rate.</p>
<p class="calibre7">"Can you jerk-slew it?" snapped Peter.</p>
<p class="calibre7">Henderson's white-knuckled hands moved. The drive ceased.</p>
<p class="calibre7">"What in hell goes on!" roared Hogarth, coming out of his chair.</p>
<p class="calibre7">"I'm not relieved of command," replied Peter. "Sit down!"</p>
<p class="calibre7">Henderson hit the steering drivers and turned the free-flying ship
sidewise to its course.</p>
<p class="calibre7">"Now!"</p>
<p class="calibre7">Henderson hit the power lever as hard as he could. The <i class="calibre8">Vanguard</i>
headed out on a vector-angle to its course, leaving the proscribed
orbit at the maddeningly slow crawl of feet per second. At the same
thirty-odd gravities, it still took time to put some space between the
tail of the ship and the course upon which it had been running.</p>
<p class="calibre7">The angle was a backwards drive by some degrees. The effect was almost
exactly the same as if the quarry had stopped and then angled sharply
on its course. The fact that the <i class="calibre8">Vanguard's</i> velocity with
respect to Sol (or anything else in the universe) could be measured in
thousands of feet per second had nothing to do with it. Relativity.
The important thing was the <i class="calibre8">Vanguard's</i> course and velocity with
respect to the missile.</p>
<p class="calibre7">The missile, aware in its delicately-balanced circuits that the target
had swooped aside, was forced to repeat the same maneuver.</p>
<p class="calibre7"><i class="calibre8">After</i> it had seen the maneuver performed.</p>
<p class="calibre7">In spacial terms, the maneuvers of ship and missile could be described
as "right-angling" away from their former course; but in relative
terms, as seen from the ship, the missile seemed to perform a sharp
curve in pursuit of its target ... but not sharp enough. It missed.
And the <i class="calibre8">Vanguard</i> had another few minutes of respite; a few
precious yards of safety.</p>
<p class="calibre7">In no man's mind was the idea that this spelled defeat for the
Ellsworth Self-Guided Missile. The first knockdown does not end a
prize-fight; in fact, the journey of a thousand miles begins with
a single step. The <i class="calibre8">Vanguard</i> had been on the defensive from
the beginning, and the entire criterion of the exercise was whether
the <i class="calibre8">Vanguard</i> and its crew could make Earthfall in one,
well-integrated piece.</p>
<p class="calibre7">Peter watched Henderson eye the radar screen and begin to get set
for the same maneuver again. Then he opened his intercom and called:
"Countermeasures? Get with the After Battery and see how fast you can
rig up a fast-time electronic switch. Can you patch one between the
pressor-battery and the barrier screen?"</p>
<p class="calibre7">"Probably. Why?"</p>
<p class="calibre7">"You've got to push that thing in the face and then cover your own face
when it shoots back. You'll have a little longer time if you can make
it a one-two-three with the screen, the main battery of beams, and then
the pressor. Get it?"</p>
<p class="calibre7">"On the hop, sir."</p>
<p class="calibre7">Peter looked at Commander Hogarth. The commander was sitting tense in
his chair, his elbow on the computer's table, his chin cupped in his
hands. There was a completely nondescript expression on Hogarth's face.
If the obvious willingness of the crew to leap to Peter Ellsworth's
slightest suggestion irked him, it did not show.</p>
<p class="calibre7">And of the latter there was plenty of evidence. There was a ring to
the voice of Countermeasures—a sound of confidence. The tone of a
man who knew and respected the person and the abilities of Peter
Ellsworth. There had been a sort of friendly rivalry when Peter had
come aboard: Peter had been the renegade who had gone over to the other
side. But now he was back; and that he was back—and working against
himself—because his hide depended upon it seemed unimportant. The
basic fact was that of Peter's return.</p>
<p class="ph">IV</p>
<p class="calibre7">Plates groaned and girders complained as Henderson went into the
jerk-slew maneuver again. And the missile missed again, simply because
it was a trailing device and had no precognition.</p>
<p class="calibre7">But it was a losing fight. Respite for the moment was gained—but
this could not go on forever. Each dodge brought the flaming death of
the missile's warhead nearer to them, so far as actual distance was
concerned; it merely brought it nearer "slower." The <i class="calibre8">Vanguard</i>
was the clever rabbit running from the dog. But there was no bramble in
which to find safety.</p>
<p class="calibre7">Peter studied the ranges, then glanced at the screen that diagrammed
the ship's course during such an operation. He grinned faintly. So far
the <i class="calibre8">Vanguard</i> had eluded the missile; but if this had been a real
space engagement, the <i class="calibre8">Vanguard</i>, in its preoccupation with the
missile, would have been a sitting duck for the enemy ship that had
released it.</p>
<p class="calibre7">The squawk-box said: "The gizmo is connected as you suggested, sir."</p>
<p class="calibre7">Peter said, "Good. Let it rip!" He turned to Henderson. "Let's go,
Henny. Straightaway, fast and hard!"</p>
<p class="calibre7">Henderson leaned down on the levers, made the dodge, and went
straightaway.</p>
<p class="calibre7">"Can you line up with our other course?"</p>
<p class="calibre7">"Sure ... but why? Intrinsic velocity doesn't mean a thing. We're
fighting one another, not one-another-with-respect-to-Sol. As far as
relative positions go, we're just standing still and all I'm doing on
these levers is running your missile back and forth in space."</p>
<p class="calibre7">"I know; but I have an idea."</p>
<p class="calibre7">Henderson nodded and fiddled with his levers again until the course was
lined up with the previous line of flight.</p>
<p class="calibre7">"Okay, idea ahead," he said. He set the rate-of-rise dial as high as
he could without winking on the alarm lamp and began to lean back.</p>
<p class="calibre7">"Don't relax yet. This might not work."</p>
<p class="calibre7">"I'm not relaxed. I won't be relaxed until I'm back on Mars, steering
my blonde around a crowded dance floor."</p>
<p class="calibre7">From below came the alternate hiss and click of equipment, and on
the radar screens there was an off-and-on stuttering. The deadly,
eye-searing columns from the main beam-battery lashed out, flickered
a moment against the inside of the <i class="calibre8">Vanguard's</i> defense-barrier;
then the barrier winked off and the beams drilled down at the missile,
to splash aside as spectacularly harmless. A moment later the beams
themselves winked out; and the missile's pearly-radiant barrier, its
stimulus gone, died also. Instantly the pressors slammed their thick
columns against the missile's nose. They gave a hard, powerful thrust,
then were cut off. The <i class="calibre8">Vanguard's</i> barrier leaped up again just
in time to stop the missile's counter-attack.</p>
<p class="calibre7">It was <i class="calibre8">bang! press! cover-up!</i> ... again and again and again.</p>
<p class="calibre7">"Are we making any headway?"</p>
<p class="calibre7">"The range-record says we're not losing ground as fast as we were."</p>
<p class="calibre7">Peter took a breath. "We'll hit a balance point," he predicted.</p>
<p class="calibre7">"When?"</p>
<p class="calibre7">"Pressors exert force in inverse proportion to the range. So—the
closer that thing of mine comes, the harder it'll get pushed back.
Eventually the thrust versus the missile's drive will reach a balance."</p>
<p class="calibre7">Henderson nodded. "And when does that goddammed monster of yours run
out of power so we can leave it here and go home to my blonde?"</p>
<p class="calibre7">"It's got about twice as much reserve as the <i class="calibre8">Vanguard</i>."</p>
<p class="calibre7">Henderson groaned and looked at the range-record; it was mildly
heartening. The missile had closed from ten thousand yards to five
thousand yards in a matter of a minute; but the next twenty-five
hundred yards had taken a bit more than a minute, and the next section
of twelve-hundred fifty almost two minutes.</p>
<p class="calibre7">The process of <i class="calibre8">bang! press! cover-up!</i> continued.</p>
<p class="calibre7">Every eye on the <i class="calibre8">Vanguard</i> watched and every mind was busy with
the same computation. And in a half hour the missile had closed up
to a couple of hundred yards and was, to all intents and purposes,
stationary with the ship. As far as the missile was concerned, its
driving thrust was now equal to the resistance it encountered, and so
it no longer moved.</p>
<p class="calibre7">Henderson asked: "May I relax now?"</p>
<p class="calibre7">"Until we can think of something, yes."</p>
<p class="calibre7">Hogarth sat up, cleared his throat, and said, "You've done half a job,
Ellsworth. Keep it up."</p>
<p class="calibre7">Peter eyed the commander. "What do you mean?"</p>
<p class="calibre7">"I hate to admit this, but the rules regarding self-guided missiles
state no time-limit. From a statistical point of view, you're
a fifty-fifty success, so far. If this were a real engagement,
the <i class="calibre8">Vanguard</i> would now be considered immobilized ... your
one-million dollar missile has immobilized a fifty million dollar
spacecraft. So only until we finish this job can anybody come up with a
decision. So go right ahead, Ellsworth."</p>
<p class="calibre7">Peter grunted. "Now <i class="calibre8">you're</i> thinking about this as a game,
Hogarth. This is no time to yap about contracts." He turned to the
intercom and asked:</p>
<p class="calibre7">"Supplies! Have you got a spare Lanson?"</p>
<p class="calibre7">"Three of 'em."</p>
<p class="calibre7">"Crew hear this: Maintenance prepare to jury-rig the ship's spares for
operation. Engineering, prepare to connect the control circuits to the
existing servos." He glanced at Hogarth. "We may get out of this yet!"</p>
<p class="calibre7">"How?"</p>
<p class="calibre7">"We've one chance," said Peter. "And it'll take time. You see, the
Lanson field tends to neutralize mass. The missile has no Lanson
generator because it is not equipped with a crew that starts to fold up
under a few gravities."</p>
<p class="calibre7">"That's a great help," snorted Hogarth.</p>
<p class="calibre7">"Damn right it is! If we can set up a terrific Lanson field we can
neutralize our mass ... then we can run up our acceleration to some
really high values! We can probably approach velocities in the region
where the Einstein increase in mass becomes considerable; but since
our mass will be neutralized, we can squeeze right up in there near
Constant. And the missile, having no Lanson, won't be able to make it.
We can then run away from it."</p>
<p class="calibre7">"You can't neutralize that much mass."</p>
<p class="calibre7">"I know it. But even one Lanson field in the ship will do the job of
making fifty gravities feel like three. So pack two of 'em side by side
and you can double it, at least—"</p>
<p class="calibre7">"Fifty times the square-root of two times fifty, plus—"</p>
<p class="calibre7">"—all right, we'll go through the figures later. But it adds up."</p>
<p class="calibre7">"Right. That it does."</p>
<p class="calibre7">"And with four of 'em—"</p>
<p class="calibre7">Henderson turned back to his radar for a moment and then shook his
head. "You sound like the guy who installed three fifty-percent
power-savers on his crate and had to bale out the gas-tank every thirty
miles! What're you trying to do? Get half-way to Centauri?"</p>
<p class="calibre7">Ellsworth shrugged. "We're half way to Hell right now."</p>
<p class="calibre7">They all turned to watch the screens. This, if anything, was worse than
before. There had been a tenseness, then; the excitement had poured
adrenalin into the veins and tuned them high. There had been deadly
danger, averted only by some very fast and rough action.</p>
<p class="calibre7">But now the deadly danger was back there, dogging their heels by a
couple of hundred yards.</p>
<p class="calibre7">It was held rigidly at that distance by the pressors, which were
protected by the fast flash of the barrier screen, and given their
opportunity to press down by the switching needs of the missile's own
circuitry.</p>
<p class="calibre7">The crew could do nothing ... nothing but watch; for the super-fast
electronic switches could outperform the human mechanism by at least a
thousand to one. So instead of being tensed for action—human beings
toned into momentary supermen by adrenalin—these same human beings sat
and worried about the missile because they now had the time to sit and
worry.</p>
<p class="calibre7">All it would take to blast them into nothing-much was to have a fuse
blow or a tube kick out or a capacitor break down or a resistor
overload or a transformer flash over or a circuit breaker crash
open ... so many things could go haywire. To be sure, such a failure
could be repaired in a matter of five minutes by this particular crew
of technical experts. But five minutes was about four minutes and fifty
nine seconds too late.</p>
<p class="calibre7">It took a little longer than it should have taken to rig the auxiliary
Lanson generators, because the gang was busy taking quick looks out
of the after-ports or into the radar screens to see their nemesis.
But eventually they got the extra generators rigged, and then, with
specialized men sitting at various relay stations to observe the
possible effects of overload, Henderson cut them in and at the same
time upped the rate-of-rise dial.</p>
<p class="calibre7">The accelerometer on Henderson's instrument board quietly zipped
across the scale, bent the needle against the safety-peg, and then
after waiting for a few minutes, gave up. A small cloud of white
smoke obscured the scale; that meter would smell like hell when the
meter-repair man took it apart. Of course, it was useless anyway.
Normal accelerometers depend upon the apparent increase in the
gravitational constant. But on a spacecraft where a Lanson generator
is used to create a neutralization of part of the mass so that the
acceleration can run high without crushing the crew, the accelerometer
was a complex integrating circuit that measured the power going into
the Lanson, compared it to the power that went into the drivers,
measured the true gravity of what was left, performed some internal
computations and came up with an electrical current that registered on
the control panel.</p>
<p class="calibre7">With three Lansons running beside the normal one, and the drivers
pushing far beyond their usual scope, the power was so far above its
top reading of fifty-gravity emergency power that the accelerometer was
useless.</p>
<p class="calibre7">Peter rigged up the doppler spectrograph and tried to get an estimate
of how fast they were going away from Sol. It was a good try, but
it failed; the constant flash-flash-flash of the main battery of
the missile, mingled with the ripostal flash-flash-flash of the
<i class="calibre8">Vanguard</i>, loused up the observations. Not even the heavens
forward could be seen through the blaze.</p>
<p class="calibre7">Henderson called Engineering, and soon a sequence-camera was being
rigged—one that would be open only when the flashing was off.</p>
<p class="calibre7">"Now," said Peter, "we wait."</p>
<p class="ph">V</p>
<p class="calibre7">Hours passed. Velocity mounted. The missile was still dogging their
tracks. It stayed about two hundred yards back, retreating a bit under
the lash of the pressors and coming up between thrusts. Its average
distance had not changed.</p>
<p class="calibre7">The worry and concern over a possible failure was almost gone. With
nothing to do but fret, the crew to a man had spent their time
buttering up their hastily-rigged circuits. The first electronic switch
had been augmented by another one and semi-connected, so that in case
of a failure in the first the second would cut in with no more than
one single sequence of failure. Men sat over the Lanson generators,
watching. The back covers were off and set aside and the crew worked
over them with test equipment. Voltages and currents were read from
point to point and the alignment was under constant observation. Parts
were replaced by the techniques once started by the telephone companies
of an early Terrestrial Era, who learned how to transfer the lines
from one cable to another, and from one central office switchboard
to another, without causing the man who might be using one of the
lines to suspect that his voice had suddenly changed its route. Of
all of the various operations, only the doppler spectrograph proved
a flat failure. The sequence-camera was set up and tried; but the
time-interval between exposure and development was too long to permit
the careful focusing of the instrument on Sol. All they got was smudge
after smudge.</p>
<p class="calibre7">Then they gave up, because someone down in Observation cried: "We're
pulling away!"</p>
<p class="calibre7">Everybody went below.</p>
<p class="calibre7">It was true. The sequence of flashing had changed, too; but the
important thing was that—perceptibly—the missile was receding.</p>
<p class="calibre7">Slowly it dropped back and back until it was no more than a mote in the
distance.</p>
<p class="calibre7">Warily, the fire-push-barrier system was shut off.</p>
<p class="calibre7">Radar reported the missile as fifty thousand yards behind and losing
range.</p>
<p class="calibre7">No one heard Radar except vaguely. What they were more interested in
was the sight of space around them.</p>
<p class="calibre7">It was a complete and total blank. Not a star, no trace of Sol, not
a smudge of distant galaxy or even the slight luminosity of galactic
gases. The sky in any direction was a complete and horrid black nothing.</p>
<p class="calibre7">It was Peter that said it: "No one knows how fast we've been
accelerating. But let's face it: we can't expect much measureable
increase in mass until we get into the upper brackets of velocity.
We're probably running to within a few tenths of a percent of the
velocity of light."</p>
<p class="calibre7">Hogarth shook his head. "We haven't had time. To accelerate to the
velocity of light with ten thousand gravities would take—"</p>
<p class="calibre7">Peter nodded. "And we haven't ten thousand, I'm sure. But don't forget
that we may have been running on subjective time, too."</p>
<p class="calibre7">"Huh?" said Hogarth.</p>
<p class="calibre7">"Time ceases to exist for those running at Constant."</p>
<p class="calibre7">"And—?"</p>
<p class="calibre7">"As you approach the speed of light time slows down toward zero."</p>
<p class="calibre7">"Just what do you mean?"</p>
<p class="calibre7">"Just what I said."</p>
<p class="calibre7">Henderson groaned. "My blonde," he complained. "Not only have I stood
her up, but she'll be a hag by the time we get back."</p>
<p class="calibre7">Hogarth snarled, "Henderson, shut the hell up! I've got a wife and kids
back there that I'd hate to find gone. Forget that damned blonde of
yours. She's probably unfaithful anyway."</p>
<p class="calibre7">Henderson chuckled. "That's what bothers me. I know she is—"</p>
<p class="calibre7">Hogarth started to roar, and Henderson shut up finally.</p>
<p class="calibre7">"So what do we do now?" asked Hogarth of Peter.</p>
<p class="calibre7">"We can't just swap ends, because my missile will continue on its
normal course," he said thoughtfully. "What we've got to do is to
continue accelerating for some time, but adding a sidewise component
to our course once we know that we are out of detection range of the
missile. Then we can turn around and head back."</p>
<p class="calibre7">"And what's the detection range?"</p>
<p class="calibre7">"I'm not sure. As good as ours or better."</p>
<p class="calibre7">"Radar!" bawled Hogarth. "Radar, fire up that loused-up Z-wave radar
hookup of yours and see if you can catch that asterisked missile."</p>
<p class="calibre7">"That's what I'm worried about mostly," said Peter. "I have a Z-wave
locator in the missile, too. It runs on gravitics, you know, which
have an instantaneous speed of propagation; the range is limited to the
power. It would—"</p>
<p class="calibre7">The squawk-box opened up and said: "According to this Z-wave gewgaw,
your missile is almost three thousand miles behind. Fading fast. Four
kilos now, and you can make that five by the time I end this gab.
Yah—five!"</p>
<p class="calibre7">"—normally begin to come weak at about twenty thousand miles,"
continued Peter. "But if we're hipping it up close to the speed of
light, our mass must be something terrific, and that extends the
effectiveness of the Z-wave, too."</p>
<p class="calibre7">"But the Lanson—"</p>
<p class="calibre7">"The field from the Lanson generator is local. And even so, it has
nothing to do with the Einstein Increase. So far as the outside
universe goes we are a massive something-or-other traversing space at
a velocity near to that of light. I'm of the opinion that we are near
enough to Constant so that the increase in mass has gone high enough to
produce the Einstein warping of the space fields. That's why no light
is getting in."</p>
<p class="calibre7">No one felt too much like arguing with Peter. Radar eventually reported
that the missile had dropped beyond range. Hogarth looked at Peter, who
still shook his head. "Let's run like this for another hour," he said.
"I'd like to be sure."</p>
<p class="calibre7">If anybody ever got around to plotting it, the course of the
<i class="calibre8">Vanguard</i> would be magnificent ogee curve, covering an
astronomical distance.</p>
<p class="calibre7">They had come straight out from Sol. Now the <i class="calibre8">Vanguard</i> stopped
accelerating along the line of flight, turned sidewise, and started
to accelerate in a direction at right angles to the original course.
Since the <i class="calibre8">Vanguard</i> still moved in the original direction at a
constant velocity but was now adding the sidewise component, the course
would take the shape of a logarithmic curve. Peter Ellsworth and Henry
Henderson, the pilot, drove the <i class="calibre8">Vanguard</i> for four solid hours
in this sidewise direction; then, of course, it was necessary to swap
ends with the ship to decelerate another four hours.</p>
<p class="calibre7">The end-product of this maneuvering was to place the <i class="calibre8">Vanguard</i>
on a parallel course to the original, but displaced by some distance
astronomically high enough to permit the ship to return without meeting
the missile.</p>
<p class="calibre7">The stars returned after a long interval of deceleration. They appeared
in that outside field of awesome blackness as faint misshapen smudges
of spread-out light that showed a tendency to coalesce. The stars
condensed slowly, looking like the effect on the ground glass of a
camera during a focusing operation. It was some time before they
actually sharpened down to their familiar pinpoint appearance, and
even then there was a definite fore-to-aft dissimilarity in color: the
<i class="calibre8">Vanguard</i> was still going faster than any ship ever had.</p>
<p class="calibre7">But of more interest to the crew, who watched with their hands ready
to crash down on the switches that controlled the system that held the
missile at bay, was the sky nearby. The missile must not be there.
It could not be there. By all of the laws of logic and of science it
should not be there. The <i class="calibre8">Vanguard</i> could be pronounced safe if
the theory held true: If A cannot detect B, then B can not detect A,
all other things being equal.</p>
<p class="calibre7">The theory seemed to hold true. No missile. The crew relaxed.</p>
<p class="calibre7">"Which is Sol?" asked Hogarth. "It doesn't show a disc."</p>
<p class="calibre7">"We must have cut us up quite a distance," said Peter. "But we're not
lost. That's Sol right there; the bright one that doesn't belong in
that constellation. Catch it?"</p>
<p class="calibre7">Hogarth nodded. "Let's get there. For one thing, I want to find out
about this subjective-objective time business."</p>
<p class="calibre7">Peter nodded. He swung the dials and centered the viewplate on a binary
below. "That's Centauri," he said. "But we can't tell how close we are
to it, any more than we can measure the distance back to Sol. We can
compute it when we get back, maybe. But let's face it, we probably are
not more than a few light-weeks out from Sol, which means that we've
spent some real weeks of time en route. Say six. Maybe eight. So what?
We'll get those answers when we get back home. But for the moment,
Commander Hogarth, may I now resign from my post? I have succeeded in
carrying out your orders; I have eluded the Ellsworth Self-Guiding
Missile. Your <i class="calibre8">Vanguard</i> is in one piece. We can now return and
make Terrafall in one chunk." He sighed. "Peter Ellsworth is a flat
failure as a design engineer and a total loss as a financial risk. I'd
like to take my somewhat mingled feelings somewhere and nurse them."</p>
<p class="calibre7">"Mingled?"</p>
<p class="calibre7">Peter nodded. "Mingled. This has been a rough row to hoe: I've invented
the missile that no man could louse-up, and then I've had to go out and
louse it up in order to keep my hide whole. I'm almost convinced that
it isn't too bad to be a dead hero."</p>
<p class="calibre7">Hogarth said gruffly, "If that's the way you feel, you're relieved of
duty. You will get my official recommendation. Okay?"</p>
<p class="calibre7">"Okay as it can be, I guess. I'm going to my quarters. Wake me up when
we get to Terra."</p>
<p class="calibre7">The <i class="calibre8">Vanguard</i> came down onto the vast sands of the desert
spaceport, where it was met by hordes of military bigwigs and sobbing
relatives. The crewmen were enfolded by the latter. Hogarth went into
the Countermeasures office to report. Henderson hiked to the telephone
to see what he could do about repairing the damaged affections of his
stood-up date.</p>
<p class="calibre7">Peter looked at the men who had come to meet him. They piled him into
their car and drove back to Operations.</p>
<p class="calibre7">"Well?" one of them asked coldly.</p>
<p class="calibre7">Peter explained.</p>
<p class="calibre7">"But you were so damned certain."</p>
<p class="calibre7">"I know what to do—"</p>
<p class="calibre7">"Forget it, Ellsworth. Forget it. No man has ever made anything that
someone couldn't un-make. So what do we do about the investments?"</p>
<p class="calibre7">"I'll pay it back."</p>
<p class="calibre7">"With what?"</p>
<p class="calibre7">Peter shook his head. "Tactically, there is a good chance that the
thing will be acceptable. You see, even though we got away from it, the
missile immobilized the <i class="calibre8">Vanguard</i> for about—what was it?—four
months?"</p>
<p class="calibre7">"Not good enough. A normal contract for making these things doesn't pay
high enough to make it worth while. The initial contract-grant would
have paid us back neatly if we'd been able to follow the stipulations.
We invested on a short-term proposition, and none of us can afford the
long-term contract."</p>
<p class="calibre7">"There's this," suggested Peter. "We can put a Lanson in the missile—"</p>
<p class="calibre7">"No good. The first thing that OpNav is going to do is to install
multiple Lanson gear in the ships. You're licked."</p>
<p class="calibre7">Peter nodded.</p>
<p class="calibre7">"That isn't all. You're bankrupt."</p>
<p class="calibre7">Hogarth came into Operations. "Got some news, Ellsworth. OpNav is going
to install the multi-Lanson equipment in their crates. They'll assume
that you were the inventor and pay you a fee—"</p>
<p class="calibre7">"How much?" one of Peter's backers asked bluntly.</p>
<p class="calibre7">Hogarth smiled. "They're looking up Peter's financial status right now.
The fee will be made exactly the amount that Peter Ellsworth borrowed
from you gentlemen to create the Ellsworth Missile."</p>
<p class="calibre7">"Excellent!" the backer said.</p>
<p class="calibre7">Peter grunted. "Broke but honest. Why not add me a couple of dollars?"</p>
<p class="calibre7">Hogarth shook his head. "With you broke and no future," he said slyly,
"there's only one thing for you to do. You'll have to rejoin the Force."</p>
<p class="calibre7">One of Peter's creditors asked: "You'll turn over that payment, of
course?"</p>
<p class="calibre7">Peter nodded. "We'll accept."</p>
<p class="calibre7">They left him, then. He stood there by the window, looking out across
the bald spaceport. The <i class="calibre8">Vanguard</i>, empty and deserted, stood
against the sky a few miles away like a monument to his big flop. Gone
were his hopes, his ambitions, his chances to make a barrel of cash so
he could retire and spend the rest of his life tinkering with doodads
and gadgets as he pleased. He was no longer bankrupt; but it stood to
reason that he was looking at his next home: the <i class="calibre8">Vanguard</i>. He'd
have to re-enter the Service, and when he did they'd toss him into his
old job again. Peter could see nothing more for the rest of his active
life than driving the ship up and down the solar system.</p>
<p class="calibre7">"Damn it!" he breathed bitterly. "I wish that missile had hit us!"</p>
<p class="calibre7">There came the sudden scream of a siren; it broke off to permit
the stertorian roar of the landing field's monster speaker to cry:
"<i class="calibre8">Battle Stations!</i>"</p>
<p class="calibre7">Men raced out across the field; projectors swiveled around to point
upwards and vomit beams of energy that seared the air and made the
screech of the siren pale by comparison; a launching station across the
field slapped a rising web of missiles across the sky—</p>
<p class="calibre7">No one saw it.</p>
<p class="calibre7">But there was a burst of intolerable light across the field that
expanded into veritable sunshine. Heat tightened Peter's face as he
took a step backward. The blast came next, to shatter the windows. The
room filled with the tinkle of falling glass. The shock tore at Peter,
spinning him half around before it hurled him to the floor. Plaster
sifted down on him. The ground itself shook.</p>
<p class="calibre7">Out where the <i class="calibre8">Vanguard</i> should have been was the beginning of a
pillar of white billowing smoke.</p>
<p class="calibre7">Peter looked at the pillar rising towards the stratosphere.</p>
<p class="calibre7">He did not look blankly, nor uncomprehendingly. He looked with
gratification. All he had to do now was to talk his way out of the fact
that there was one hell of a big hole in Terra's finest spaceport and a
lot of busted glass to account for.</p>
<p class="calibre7">Peter Ellsworth's mind was busily planning his next gadget as he left
Operations to find Hogarth.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?da7b50d0